exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap[data-v-7b5595d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.wrap .item[data-v-7b5595d2]{cursor:pointer}.wrap .item .item__icon[data-v-7b5595d2]{width:100%}", ""]);

// exports
